import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function OfferPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen" style={{ background: 'var(--app-bg)' }}>
      <nav className="border-b px-4 py-3" style={{ background: 'var(--app-sidebar)', borderColor: 'var(--app-border)' }}>
        <div className="max-w-4xl mx-auto flex items-center gap-2">
          <Link to="/" className="flex items-center gap-1.5 hover:opacity-80">
            <img src="/logo.png" alt="" className="w-8 h-8 rounded-md object-cover" />
            <span className="font-heading text-sm"><span style={{ color: 'var(--app-text-secondary)' }}>Pro</span><span style={{ color: 'var(--app-accent)' }}>Praxis</span></span>
          </Link>
        </div>
      </nav>
      <article className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="font-heading text-2xl sm:text-3xl mb-2" style={{ color: 'var(--app-text)' }}>Публичная оферта</h1>
        <p className="text-sm mb-8" style={{ color: 'var(--app-text-muted)' }}>Лицензионное соглашение на использование сервиса «ProPraxis»</p>
        <div className="space-y-6" style={{ color: 'var(--app-text-secondary)' }}>

<Section title="ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ">
<P><strong>Лицензиар</strong> — ИП Алякаев Камиль Рустамович (ОГРНИП 326774600115050, ИНН 056114276774).</P>
<P><strong>Пользователь (Специалист)</strong> — физическое лицо, ИП или самозанятый, прошедший регистрацию в Сервисе.</P>
<P><strong>Клиент Пользователя</strong> — третье лицо, получатель услуг Пользователя, чьи данные вносятся в Сервис.</P>
<P><strong>Сервис «ProPraxis»</strong> — SaaS-платформа для автоматизации расписания, финансового учета, веб-визиток и хранения файлов.</P>
</Section>

<Section title="1. ПРЕДМЕТ СОГЛАШЕНИЯ">
<P>1.1. Настоящий документ является публичной офертой (ст. 437 ГК РФ). Регистрация в Сервисе признается полным акцептом (ст. 438 ГК РФ).</P>
<P>1.3. Лицензиар предоставляет простую (неисключительную) лицензию на использование Сервиса в пределах выбранного Тарифа.</P>
<P>1.5. Лицензиар предоставляет исключительно техническое решение и не участвует в правоотношениях между Пользователем и его Клиентами.</P>
</Section>

<Section title="2. ПРАВА И ОБЯЗАННОСТИ СТОРОН">
<P><strong>Пользователь обязан:</strong> использовать Сервис в соответствии с законодательством РФ; самостоятельно получать согласия Клиентов на обработку ПДн; обеспечивать сохранность логина и пароля; не загружать вредоносный код.</P>
<P><strong>Пользователь имеет право:</strong> использовать функционал 24/7; изменять Тариф; обращаться в поддержку.</P>
<P><strong>Лицензиар обязан:</strong> предоставить доступ; принимать меры для сохранности данных (шифрование, резервное копирование).</P>
<P><strong>Лицензиар имеет право:</strong> вносить изменения в функционал; приостанавливать работу для профилактики; блокировать нарушителей.</P>
</Section>

<Section title="3. ХРАНЕНИЕ ДАННЫХ И ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ">
<P><strong>3.1. 152-ФЗ:</strong> В отношении данных Клиентов Пользователь является Оператором ПДн. Лицензиар — обработчик по поручению.</P>
<P><strong>3.2. Ответственность:</strong> Пользователь несет единоличную ответственность за загружаемые файлы и их законность.</P>
<P><strong>3.3. «Как есть» (As Is):</strong> Сервис предоставляется без гарантий бесперебойной работы. Максимальная ответственность Лицензиара ограничена суммой оплаты за последний месяц.</P>
<P><strong>3.4. «Умный импорт»:</strong> Используются API нейросетевых моделей на серверах в РФ (Яндекс.Облако). Пользователь обязан проверить распознанные данные перед сохранением.</P>
</Section>

<Section title="4. ФИНАНСОВЫЕ УСЛОВИЯ И ТАРИФЫ">
<P><strong>4.1.</strong> Базовый тариф «Старт» — бесплатно. Расширенный функционал — платная Подписка.</P>
<P><strong>4.3. Автопродление:</strong> При оплате Пользователь даёт согласие на рекуррентные платежи. Списание в последний день оплаченного периода.</P>
<P><strong>4.4. Отмена:</strong> Пользователь может отменить автопродление в личном кабинете до момента списания. Доступ сохраняется до конца оплаченного периода.</P>
<P><strong>4.5. Возвраты:</strong> Возврат средств за текущий оплаченный период не производится (ст. 429.4 ГК РФ «Абонентский договор»).</P>
</Section>

<Section title="5. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ">
<P>Соглашение действует бессрочно. Споры решаются путем переговоров (досудебный порядок 30 дней), затем в суде по месту нахождения Лицензиара.</P>
</Section>

<Section title="6. РЕКВИЗИТЫ ЛИЦЕНЗИАРА">
<P>ИП Алякаев Камиль Рустамович</P>
<P>ИНН: 056114276774 | ОГРНИП: 326774600115050</P>
<P>Адрес: г. Москва, ул. Кастанаевская 43к2</P>
<P>Телефон: +7 (985) 312-94-07</P>
</Section>

        </div>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-heading text-lg mb-3" style={{ color: 'var(--app-text)' }}>{title}</h2>
      <div className="space-y-2 text-sm leading-relaxed">{children}</div>
    </div>
  );
}

function P({ children }) {
  return <p>{children}</p>;
}
